<ng-container *ngIf="isMobileView$ | async as isMobileView">
  <a *ngIf="isMobileView.state" class="flex cursor-pointer" (click)="toggle()">
    <ng-container *ngIf="mobileNav$ | async as mobileNav">
      <sky-svg-icon *ngIf="!mobileNav.expand" icon="hamburger" size="w-8"></sky-svg-icon>
      <sky-svg-icon *ngIf="mobileNav.expand" class="-ml-2" icon="close" size="w-12"></sky-svg-icon>
    </ng-container>
  </a>
  <div class="ml-auto flex">
    <figure class="w-fit"><img src="assets/img/logo.svg" alt="Logo aplikacji" /></figure>
    <figure *ngIf="!isMobileView.state" class="w-fit ml-8 self-end">
      <img src="assets/img/powered-by-skycash.svg" alt="Logo SkyCash" />
    </figure>
  </div>
</ng-container>
